import React from "react";
import "../../styles/shared/LoadingState.css";

interface PageSpinnerProps {
  label?: string;
}

const PageSpinner: React.FC<PageSpinnerProps> = ({ label = "Loading..." }) => {
  return (
    <div className="page-center-spinner" role="status" aria-live="polite" aria-busy="true">
      <span className="page-center-spinner__indicator" aria-hidden="true" />
      <span className="page-center-spinner__label">{label}</span>
    </div>
  );
};

export default PageSpinner;
